import { FilterInput, InputMessage } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { useApiErrorHandlingAsync } from '../../../../../hooks/auth'
import {
  TKeyBuilder,
  useWriskTranslation,
} from '../../../../../infrastructure/internationalisation'
import { usePrincipal } from '../../../../authentication'

interface VehicleModelsFilterProps {
  onSelect: (model: string | undefined) => void
  profile?: string
  year: number
  make: string
  model?: string
  tKey: TKeyBuilder
}

const renderOption = (model: string) => model

const matchOption = (text: string) => (option: string) =>
  option.toLowerCase().includes(text.toLowerCase())

export const VehicleModelsFilter: FunctionComponent<VehicleModelsFilterProps> = ({
  onSelect,
  profile,
  year,
  make,
  model,
  tKey,
}) => {
  const { t } = useWriskTranslation()

  const { apiClient } = usePrincipal()

  const asyncDataEntries = useApiErrorHandlingAsync(
    async () => await apiClient.lookupVehicleModels({ year, make }, profile),
    [],
  )

  return asyncDataEntries.result?.length === 0 ? (
    <InputMessage width={1}>
      {t(tKey('errors', 'no_results'), { year, make })}
    </InputMessage>
  ) : (
    <FilterInput
      data-testid='vehicle-model'
      width={1}
      placeholder={t<string>(tKey('placeholder'))}
      value={model}
      onSelect={onSelect}
      options={asyncDataEntries.result || []}
      renderOption={renderOption}
      renderOptionText={renderOption}
      matchOption={matchOption}
    />
  )
}
